<template>
  <b-card title="">
    <h3 class="text-primary font-weight-bold mb-2">อัพเดทข้อมูลคิวศูนย์</h3>

    <b-row>
      <b-col md="6">
        <h5 class="h4 font-weight-bold"> AL Code</h5>
        <b-form-group class="font-weight-bold" label="" label-for="IdCode">
          <b-form-input id="IdCode" v-model="formUser.IdCode" placeholder=" AL Code" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
          <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
          <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6"></b-col>
      <b-col md="6">
        <br />
        <b-button variant="primary" type="submit" @click.prevent="getDataTable" :disabled="isLoading">
          <template v-if="isLoading">
            <b-spinner small type="grow" class="mr-1" />
            กำลังค้นหา...
          </template>
          <template v-else>
            ค้นหา
          </template>
        </b-button>
        <!-- <b-button variant="primary" @click.prevent="getDataTable"> ค้นหา </b-button> -->
      </b-col>
      <br />
      <b-col md="6"></b-col>
      <b-col md="6">
        <br />
        <h3 class="text-primary font-weight-bold mb-2">
          ตารางแสดงรายการจองคิวที่ศุนย์
        </h3>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
            @change="handleItemsPerPageChange" />
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="h5 mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">ยกเลิก</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
        <template #head(select)>
          <!-- <b-form-checkbox :indeterminate="isIndeterminate" :checked="allSelected"
            @change="toggleSelectAll"></b-form-checkbox> -->
        </template>
        <template #cell(processingStatus)="data">
          <div class="d-flex flex-column">
            <div v-for="(status, index) in parsedStatus(data.item.processingStatus)" :key="index"
              class="d-flex align-items-center mb-1">
              <!-- Step number -->
              <!-- <span class="badge badge-secondary mr-2">{{ index + 1 }}</span> -->

              <!-- ชื่อขั้นตอน -->
              <!-- <span class="font-weight-bold mr-2">{{ Object.keys(status)[0] }}:</span> -->

              <!-- ค่า + สีตามผล -->
              <span :class="[
                'badge',
                badgeClass(Object.values(status)[0])
              ]">
                {{ Object.values(status)[0] }}
              </span>
            </div>
          </div>
        </template>
        <!-- Checkbox per row -->
        <template #cell(select)="row">
          <!-- <b-form-checkbox v-model="row.item._selected" @change="updateSelectAllState"></b-form-checkbox> -->
        </template>

        <template #cell(action)="props">
          <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)" title="ปริ้น">
            <feather-icon icon="PrinterIcon" />
          </b-button>
        </template>

        <template #cell(actionEdit)="props">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="editItem(props.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>แก้ไข</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>

    <!-- Pagination -->
    <b-card v-show="true" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
        </div>
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="handlePageChange"
            class="mb-0" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="left"
            hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>

    <!-- <b-row class="justify-content-center mt-3">
      <b-col cols="8" class="d-flex justify-content-center">
        <b-button variant="success" @click="MakeQueue" :disabled="!hasSelected"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'">
          ดำเนินการต่อ
        </b-button>
      </b-col>
    </b-row> -->

    <b-modal id="edit-user-modal" v-model="showEditModal" class="h3 font-weight-bold" title="แก้ไขข้อมูลผู้ลงทะเบียน"
      size="lg" hide-footer>
      <b-form @submit.prevent="saveEdit">
        <b-row>

          <b-col md="6">
            <b-form-group label-for="lastname">
              <h5 class="h4 font-weight-bold">รหัสนายหน้า</h5>
              <b-form-input v-model="editUser.agentId" placeholder="รหัสนายหน้า" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label-for="employerNumber">
              <h5 class="h4 font-weight-bold">เลขที่ประจำตัวประชาชน/ทะเบียนนิติบุคคล</h5>
              <b-form-input v-model="editUser.employerNumber" placeholder="เลขที่ประจำตัวประชาชน/ทะเบียนนิติบุคคล" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label-for="employerName">
              <h5 class="h4 font-weight-bold">ชื่อนายจ้าง</h5>
              <b-form-input v-model="editUser.employerName" placeholder="ชื่อนายจ้าง" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label-for="employerPhone">
              <h5 class="h4 font-weight-bold">เบอร์โทรนายจ้าง</h5>
              <b-form-input v-model="editUser.employerPhone" placeholder="เบอร์โทรนายจ้าง" />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="" label-for="border-select">
              <b-form-select id="border-select" v-model="editUser.BorderCheckpoint" :options="options" text-field="text"
                value-field="value" :class="{ 'is-invalid': showError && !editUser.BorderCheckpoint }" />
              <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
            </b-form-group>
          </b-col>

          <!-- แสดงจำนวนคิวที่เหลือ -->
          <b-col md="6">
            <b-card-text class="h4 mt-1 mb-0 font-weight-bold mb-2" v-if="selectedBorder && count_data != 0">
              <template v-if="out_dateDefault">
                <span class="text-primary">
                  คิวที่เหลือ:
                  <strong>
                    / {{ selectedBorder }} / {{ count_data }}
                  </strong>
                  คิว
                </span>
              </template>
              <template v-else>
                <span class="text-danger">กรุณาเลือกวันที่</span>
              </template>
            </b-card-text>
          </b-col>
          <b-col md="6">
            <b-form-group label="วันที่ศูนย์">
              <flat-pickr v-model="editUser.centerAt" class="form-control"
                :class="{ 'is-invalid': showError && !editUser.centerAt }" :config="outDateConfig" />
              <div class="invalid-feedback">กรุณาเลือกวันที่</div>
            </b-form-group>

          </b-col>

        </b-row>

        <!-- ปุ่มด้านล่าง -->
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" @click="showEditModal = false">ยกเลิก</b-button>
          <b-button variant="primary" type="submit" class="ml-2">อัพเดทข้อมูล</b-button>
        </div>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BNav,
  BCard,
  BCardText,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import { setTextStyle } from "echarts/lib/util/graphic";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
export default {
  directives: {
    Ripple,
  },
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BNav,
    flatPickr,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      isBusy: false,
      items: [],
      filter: null,
      filterOn: [],
      showEditModal: false,
      selectedBorder: null,
      fields: [
        { key: "select", label: "", sortable: false },
        { key: "no", label: "ลำดับที่" },
        { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "gender", label: "เพศ" },
        { key: "processingStatus", label: "สถานะลงทะเบียน" },
        { key: "centerName", label: "ชื่อศูนย์" },
        { key: "centerAt", label: "วันที่ไปศูนย์" },
        // { key: "DateofBirth", label: "วันเดือนปีเกิด" },
        { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
        { key: "actionEdit", label: "แก้ไขข้อมูลศูนย์" }, // ✅ เพิ่มตรงนี้

      ],
      startDate: new Date(),
      endDate: new Date(),
      showError: false,
      outDateConfig: {
        dateFormat: "d-m-Y",
        // onChange: this.handleOutDateChange.bind(this),
      },
      DateConfig: {
        dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
        altInput: true,
        altFormat: "d-m-Y",  // format ที่แสดงผล
      },
      editUser: {},
      options: [],
      formUser: {
        reqcode: "",
        IdCode: "",
      },
      out_dateDefault: null,//new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      isLoading: false,

    };
  },
  computed: {
    allSelected() {
      return (
        this.items.length > 0 && this.items.every((item) => item._selected)
      );
    },
    isIndeterminate() {
      const total = this.items.length;
      const selected = this.items.filter((i) => i._selected).length;
      return selected > 0 && selected < total;
    },
    hasSelected() {
      return this.items.some((item) => item._selected);
    },
  },
  created() {
    const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    console.log("JWT:", jwt);
    // this.getDataTable();
  },
  mounted() {
    this.getDataSelectOption();

    // Set the initial number of items
  },
  methods: {
    parsedStatus(statusString) {
      try {
        return JSON.parse(statusString);
      } catch (e) {
        return [];
      }
    },
    badgeClass(value) {
      if (["สำเร็จ", "อนุมัติ", "ผ่าน"].includes(value)) {
        return "badge-success"; // เขียว
      } else if (["รอดําเนินการ", "กำลังดำเนินการ"].includes(value)) {
        return "badge-warning"; // เหลือง
      } else {
        return "badge-danger"; // แดง
      }
    },
    statusText(status) {
      switch (status) {
        case 'confirmed':
          return 'อนุมัติ'
        case 'rejected':
          return 'ยกเลิก'
        case 'pending':
          return 'รอดำเนินการ'
        default:
          return status
      }
    },
    validate() {
      // ไม่บังคับกรอกข้อมูล
      return true;
    },
    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const res = await axios.get(`${API}config?userId=${jwt.userId}&configType=center`,
          {
            headers: {
              Authorization: await store.dispatch("getAuthorization"),
            },
          });
        console.log(res);
        const responseData = res.data.message.data;

        // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.centerName, // สมมติ field ชื่อ borderName
          text: item.centerName,
        }));

        // รวม option แรก + ตัวเลือกจาก API
        this.options = [{ value: null, text: "-- เลือกด่านชายแดน --" }, ...dynamicOptions];
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },
    formatToYYYYMMDD(dateInput) {
      let parsedDate;

      // 1. ถ้า dateInput เป็น Date object หรือ ISO string
      if (dateInput instanceof Date || /\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
        parsedDate = dayjs(dateInput);
      } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
        // 2. ถ้าเป็น string รูปแบบ DD-MM-YYYY หรือ MM-DD-YYYY
        // เราจะพยายาม parse แบบ DD-MM-YYYY ก่อน
        parsedDate = dayjs(dateInput, "DD-MM-YYYY", true);
        if (!parsedDate.isValid()) {
          parsedDate = dayjs(dateInput, "MM-DD-YYYY", true);
        }
      } else {
        // กรณีอื่น ๆ
        parsedDate = dayjs(dateInput);
      }

      if (!parsedDate.isValid()) {
        console.error("วันที่ไม่ถูกต้อง:", dateInput);
        return null;
      }

      return parsedDate.format("YYYYMMDD");
    },
    async GetChange() {
      this.handleOutDateChange(this.out_dateDefault, this.formatToYYYYMMDD(this.out_dateDefault).replace(/(\d{4})(\d{2})(\d{2})/, '$3-$2-$1'));

    }, async handleOutDateChange(selectedDates, dateStr) {

      console.log(dateStr);
      console.log(selectedDates);
      //  this.out_dateDefault = selectedDates; // อัปเดตค่า out_dateDefault ด้วย dateStr

      console.log("📅 วันที่ออก (Date object):", this.out_dateDefault); // Date object
      console.log("📅 วันที่ออกถูกเลือก:", dateStr.split("-"));
      console.log("ด่านชายแดน:", this.selectedBorder);
      // ถ้ามีวันที่เลือก ให้ set 500
      //if (selectedDates && selectedDates.length > 0) {
      if (this.selectedBorder == null) {
        console.log("Selected Border:", this.selectedBorder);
        return;
      }

      const [dayExit, monthExit, yearExit] = dateStr.split("-");
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          staffId: jwt.userId,
          date: `${yearExit}${monthExit}${dayExit}`,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}queueStatus`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log((res.data.message.centers));

        const stationData = res.data.message.centers.find(
          (station) => station.centerName === this.selectedBorder
        );
        console.log("stationData:", stationData);

        if (stationData) {
          this.count_data = stationData.remaining; // รีเซ็ตค่า count_data ก่อนคำนวณใหม่
        } else {
          console.warn("ไม่พบสถานีที่ตรงกับ:", this.selectedBorder);
          this.count_data = 0; // หรือค่า default อื่น ๆ
        }

        // console.log("API Response", stationData);
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async Getdata() {
      if (!this.validate()) return;
      await this.getDataTable();
    },
    async getDatauserFromCompany(_userId) {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          companyId: jwt.companyId,
          userId: _userId,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}userFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;

    },
    editItem(item) {
      console.log("Edit item clicked:", item);
      this.editUser = { ...item }; // clone item
      this.showEditModal = true;
      // เพิ่ม logic แก้ไข
      console.log("Edit item:", this.editUser);
      console.log(this.options);
      if (!this.editUser.BorderCheckpoint && this.editUser.centerName) {
        this.editUser.BorderCheckpoint = this.editUser.centerName;
      }

      // คำนวณจำนวนคิวที่เหลือ
      this.count_data = 0;
      if (this.editUser.BorderCheckpoint) {
        const borderData = this.items.filter(item => item.BorderCheckpoint === this.editUser.BorderCheckpoint);
        this.count_data = borderData.length;
      }
      console.log("Count data:", this.count_data);
    },
    formatToYYYYMMDD(dateInput) {
      let parsedDate;

      // 1. ถ้า dateInput เป็น Date object หรือ ISO string
      if (dateInput instanceof Date || /\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
        parsedDate = dayjs(dateInput);
      } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
        // 2. ถ้าเป็น string รูปแบบ DD-MM-YYYY หรือ MM-DD-YYYY
        // เราจะพยายาม parse แบบ DD-MM-YYYY ก่อน
        parsedDate = dayjs(dateInput, "DD-MM-YYYY", true);
        if (!parsedDate.isValid()) {
          parsedDate = dayjs(dateInput, "MM-DD-YYYY", true);
        }
      } else {
        // กรณีอื่น ๆ
        parsedDate = dayjs(dateInput);
      }

      if (!parsedDate.isValid()) {
        console.error("วันที่ไม่ถูกต้อง:", dateInput);
        return null;
      }

      return parsedDate.format("YYYYMMDD");
    },
    async saveEdit() {



      const { username, password, firstname, lastname } = this.formUser;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      //   console.log(jwt);
      console.log(this.editUser);
      // const res_data = this.items.map(async item => {

      // const registeredExitDate = this.editUser.DateooutThailand;
      // const [day, month, year] = registeredExitDate.split("-");

      // const registeredEntryDate = this.editUser.DateinThailand;
      // const [day2, month2, year2] = registeredEntryDate.split("-");

      const _data = {
        staffId: jwt.userId,
        employerName: this.editUser.employerName,
        employerNumber: this.editUser.employerNumber,
        employerPhone: this.editUser.employerPhone,
        agentId: this.editUser.agentId,
        entryId: this.editUser.entryId,
        centerName: this.editUser.BorderCheckpoint,
        centerAt: this.formatToYYYYMMDD(this.editUser.centerAt),
      }
      console.log("Data to send:", _data);

      axios
        .put(`${API}entry`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.message == "Border entry updated successfully") {
            this.$swal({
              icon: "success",
              title: "อัพเดทข้อมูล!",
              text: "อัพเดทข้อมูลสำเร็จ",
              showCancelButton: false,
              showConfirmButton: true,
              timer: 1500,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        })
        .catch(async (error) => {
          console.log(error.response);
        });
      // });
      // 🔁 ส่งข้อมูลที่ถูกแก้ไขไปยัง backend หรือจัดการใน frontend
      console.log("บันทึกข้อมูล:", this.editUser);
      this.showEditModal = false;
      this.showError = false;
    },
    async getDataTable() {
      // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
      this.isLoading = true;

      console.log("startDate type:", typeof this.startDate, this.startDate); // ⬅ เพิ่มบรรทัดนี้
      console.log(this.startDate); // ⬅ เพิ่มบรรทัดนี้

      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const formatDate = (dateObj) => {
          if (typeof dateObj === 'string') {
            dateObj = new Date(dateObj);
          }
          if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = String(dateObj.getFullYear());
          return `${day}-${month}-${year}`;
        };

        const startStr = formatDate(new Date(this.startDate));
        const endStr = formatDate(new Date(this.endDate));

        const [dayExit, monthExit, yearExit] = startStr.split("-");
        const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

        let params = {
          userId: jwt.userId,
          includeCompany: 'true',
          startDate: `${yearExit}${monthExit}${dayExit}`,
          endDate: `${yearEntry}${monthEntry}${dayEntry}`,
          emptyStationName: 'true',
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        if (this.formUser.IdCode && this.formUser.IdCode.trim() !== "") {
          params.IdCode = this.formUser.IdCode;
        }

        //   console.log("Request Params", JSON.stringify(params));

        const res = await axios.get(`${API}pendingEntry`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data.message.data);


        if (!res.data.message.data || !res.data.message.total) {
          this.items = [];
          this.totalRows = 0;
          return;
        }
        const results = await Promise.all(
          res.data.message.data.map(async (item, index) => {
            const date = new Date(item.createdAt);
            const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
            console.log("Item UserId:", item.userId);
            const datausername = await this.getDatauserFromCompany(item.userId); // <- เรียก async ได้
            console.log("datausername", datausername);
            var sp = item.createdAt.split(' ')// `${date.getFullYear()}-${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            var createdAtFormatted_img = sp[0].split('/')
            return {
              ...item,
              no: index + 1,
              //createdAtFormatted: formattedDate,
              createdAtFormatted: createdAtFormatted_img[0] + '/' + createdAtFormatted_img[1] + '/' + createdAtFormatted_img[2],//item.createdAt,
              centerAt: dayjs(item.centerAt, "YYYYMMDD").format("DD/MM/YYYY"),//item.centerAt, // ? item.centerAt.substring(6, 8) + '/' + item.centerAt.substring(4, 6) + '/' + item.centerAt.substring(0, 4) : '',
              _selected: false,
              // datausername, // <- ใส่ข้อมูลที่ได้จาก async ไปใน object
              prefix: datausername ? datausername.prefix : '',
              firstname: datausername ? datausername.firstname : '',
              lastname: datausername ? datausername.lastname : '',
              gender: datausername ? datausername.gender : '',
            };
          })
        );
        // const results = res.data.message.data.map((item, index) => {
        //   const date = new Date(item.createdAt);
        //   const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        //   // const datausername = await getDatauserFromCompany()
        //   return {
        //     ...item,
        //     no: index + 1, // ลำดับเริ่มที่ 1
        //     createdAtFormatted: formattedDate,
        //     _selected: false, // เพิ่มให้ทุกแถวมี property นี้
        //   };
        // });

        console.log(results);
        this.items = results;
        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
        this.isLoading = false;

      }
      return;
    },
    handlePrint(item) {
      console.log("พิมพ์ข้อมูล:", item);
    },
    async MakeQueue() {
      const selectedUsers = this.items.filter((item) => item._selected);
      console.log(selectedUsers);
      store.commit("addChang", selectedUsers);

      this.$router.push({ name: "updatequeue" });
    },
    async handlePageChange(page) {
      this.currentPage = page;
      this.items = [];
      await this.getDataTable();
    },
    async handleItemsPerPageChange() {
      this.items = [];
      this.currentPage = 1;
      await this.getDataTable();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleSelectAll(checked) {
      this.items.forEach((item) => {
        item._selected = checked;
      });
      this.updateSelectAllState();
    },
    updateSelectAllState() {
      // Vue will recalculate allSelected and isIndeterminate automatically
      // const total = this.items.length;
      // const selected = this.items.filter((i) => i._selected).length;
      // this.allSelected = selected === total;
      // this.isIndeterminate = selected > 0 && selected < total;
    },
  },
};
</script>
